<template lang="pug">
.date-picker-range
  v-date-picker(
    mode='dateTime',
    v-model='selectedDate',
    :popover='{ visibility: "focus", keepVisibleOnInput: false }',
    is-range,
    is24hr
  )
    template(v-slot='{ inputValue, inputEvents }')
      .date-picker-range__input
        input.date-picker-range__input__start(
          :value='parseDateTime(inputValue.start)',
          v-on='inputEvents.start',
          :disabled='disabled',
          readonly
        )
        input.date-picker-range__input__end(
          :value='parseDateTime(inputValue.end)',
          v-on='inputEvents.end',
          :disabled='disabled',
          readonly
        )
        .date-picker-range__input__clear(v-if='selectedDate && !disabled', @click='clearDate')
          image-base.date-picker-range__input__clear__icon(:src='require("@/assets/img/common/icon/close.svg")')
    template(slot='header-title', slot-scope='props')
      | {{ props.yearLabel }}年{{ props.monthLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { StartEndDateType } from '@/models/datePickerModel'
import '@/assets/css/datepicker.styl'

/**
 * 期間選択用の日付ピッカー
 */
@Component({
  components: {
    ImageBase,
  },
})
export default class DatePickerRange extends Vue {
  // 期間の開始日と終了日
  @Prop()
  startEndDate!: StartEndDateType

  // 編集不可
  @Prop({ default: false })
  disabled?: boolean

  // 開始日終了日ゲッター・セッター
  get selectedDate(): StartEndDateType {
    return this.startEndDate
  }

  set selectedDate(value: StartEndDateType) {
    this.$emit('input', value)
  }

  /**
   * 期間クリア
   */
  private clearDate(): void {
    this.selectedDate = null
  }

  /**
   * dateTimeモードはmasksが上手く動作しないのでパースする
   */
  private parseDateTime(dateStr: string) {
    const match = /(\d{4})年(\d{1,2})月(\d{1,2})日\s(\d{2}):(\d{2})/.exec(dateStr)
    if (!match) return ''

    const dateTime = this.$localDateFns.formatDateTime(
      new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]), parseInt(match[4]), parseInt(match[5]))
    )
    return `${dateTime.date} ${dateTime.time}`
  }
}
</script>

<style lang="stylus" scoped>
.date-picker-range
  display flex

  &__input
    position relative
    display flex
    gap 20px

    &__start, &__end
      height 36px
      padding 5px 20px
      border-radius 48px
      background-color var(--color-input-manager-date-picker-range__background)
      border 1px solid var(--color-input-manager-date-picker-range__border)
      transition-property background-color
      transition-timing-function ease-out
      transition-duration 300ms

      &:hover, &:focus
        border-width 2px
        padding 4px 19px
        background-color transparent

      &:disabled
        background-color var(--color-input-manager-date-picker-range__background-disabled)
        cursor default

    &__start
      width 180px

    &__end
      width 190px

    &__clear
      position absolute
      top 10px
      right 10px
      cursor pointer

      &__icon
        width 16px
        height 16px
        opacity 0.3
</style>
